'use strict';

angular.module('ntmApp').factory('ProfileMenu', function () {

    function ProfileMenu() {

        var self = this;

        profileMenuProperties = {};

        self.buildMenu = function (data) {

            var menuItems = [];
            var settingItems = _us.sortBy(data.profileProperties.profileMenu.items, 'groupPriority');

            profileMenuProperties = data.profileProperties.profileMenu;
            profileMenuProperties.items = settingItems;

            data.items.forEach(function (item) {
                buildMenuItem(menuItems, item, angular.copy(profileMenuProperties.items), profileMenuProperties.keys);
            });
            
            return menuItems;
        };

        //private methods

        function getKey(item, keys) {

            var key = {};

            keys.forEach(function (k) {
                key[k] = item[k];
            });

            return key;

        }

        function addToArray(menuItems, menuItem) {

            if (menuItem.children !== null && menuItem.label === null) {
                menuItem.label = menuItem.groupingNullLabel;
            }

            var existingItem = menuItems.filter(function (item) { return item.label === menuItem.label; })[0];

            if (existingItem && existingItem.children!==null) {
                existingItem.children = existingItem.children.concat(menuItem.children);
            } else {
                menuItems.push(menuItem);
            }            
        }

        self.updateMenuItem = function (selectedProfileMenuItem, newProfileItem) {
            selectedProfileMenuItem.entity = getUpdatedFields(selectedProfileMenuItem.entity, newProfileItem.Fields);
            selectedProfileMenuItem.keys = getUpdatedFields(selectedProfileMenuItem.keys, newProfileItem.Fields);
            selectedProfileMenuItem.alerts = newProfileItem.Alerts;

            var settings = profileMenuProperties.items;
            var profilePageEntity = selectedProfileMenuItem.entity;

            settings.forEach(function (prop) {
                var secondaryItemSeparator = prop.secondaryItemSeparator ? prop.secondaryItemSeparator : ', ';
                var secondaryItemValues = prop.secondaryItem ? prop.secondaryItem.split(',').map(function (itemName) { return profilePageEntity[itemName ? itemName.trim() : '']; }) : [];

                selectedProfileMenuItem.secondaryItem = secondaryItemValues.filter(function (itemName) { return itemName; }).join(secondaryItemSeparator);
            });
        }

      function getUpdatedFields(profileMenuItemFields, newProfileMenuItemFields) {

        for (var prop in profileMenuItemFields) {

          if (newProfileMenuItemFields.hasOwnProperty(prop)) {
            profileMenuItemFields[prop] = newProfileMenuItemFields[prop];
          }
        }

        return profileMenuItemFields;
      }

        function buildMenuItem(menuItems, item, settings, keys) {

            var menuItem = {};

            settings.forEach(function (prop) {
                settings.shift();

                var secondaryItemSeparator = prop.secondaryItemSeparator ? prop.secondaryItemSeparator : ', ';

                var secondaryItemvalues = prop.secondaryItem ? prop.secondaryItem.split(',').map(function (itemName) { return item.Fields[itemName ? itemName.trim() : '']; }) : [];

                menuItem = {
                    keys: getKey(item.Fields, keys),
                    label: item.Fields[prop.label],
                    secondaryItem: secondaryItemvalues.filter(function (itemName) { return itemName; }).join(secondaryItemSeparator),
                    grouping: settings.length > 0,
                    entity: item.Fields,
                    alerts: settings.length > 0 ? [] : item.Alerts,
                    children: settings.length > 0 ? [] : null,
                    groupingNullLabel: prop.groupingNullLabel
                };               

                if (settings.length > 0) {
                    buildMenuItem(menuItem.children, item, settings, keys);
                }

                addToArray(menuItems, menuItem);
            });

        }
    }

    return (ProfileMenu);
});
